import React, { FC, HTMLAttributes } from 'react';

import classNames from '../../helpers/classNames';
import {
  formatDay,
  formatMonthShort,
  formatWeekday,
  formatXShortDate,
} from '../../helpers/datetime';
import useBreakpoints from '../../hooks/useBreakpoints';
import useTranslate from '../../hooks/useTranslate';
import styles from './DatesTableItem.module.scss';

interface DatesTableItemProps extends HTMLAttributes<HTMLDivElement> {
  date: string;
  active?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

const DatesTableItem: FC<DatesTableItemProps> = props => {
  const { date, active, disabled, loading, className, ...rest } = props;
  const { activeLanguage } = useTranslate();
  const isBreakPoint = useBreakpoints();

  return (
    <div
      className={classNames(
        className,
        styles.wrapper,
        active && styles.active,
        disabled && styles.disabled,
        loading && styles.loading
      )}
      {...rest}
    >
      <time dateTime={date}>
        {isBreakPoint.sm ? (
          <b className="text-nowrap">{formatXShortDate(date, activeLanguage.code)}</b>
        ) : (
          <b>
            {formatDay(date, activeLanguage.code)}
            <br />
            {formatMonthShort(date, activeLanguage.code)}
          </b>
        )}
        {isBreakPoint.sm && (
          <>
            <br />
            {formatWeekday(date, activeLanguage.code)}
          </>
        )}
      </time>
    </div>
  );
};

export default DatesTableItem;
